module.exports = __webpack_public_path__ + "img/Slides_Deep_Sleep_2.jpg";